import type { InviteRow } from "./api";

/** Plain redemption count, including 0. Per #46 — never em-dash, never N/M. */
export function redemptionLabel(row: Pick<InviteRow, "redemption_count">): string {
  return String(row.redemption_count);
}

/** Remaining-of-total capacity, or ∞ for unlimited. Used for the "Übrig"
 *  column so the operator can distinguish "12 used, still open" from
 *  "12 used, no slots left". Negative remainders are clamped to 0 — the
 *  server shouldn't allow over-redemption, but the UI mustn't display "-3/2"
 *  if something does go wrong. */
export function capacityLabel(
  row: Pick<InviteRow, "max_uses" | "redemption_count">,
): string {
  if (row.max_uses === 0) return "∞";
  const remaining = Math.max(0, row.max_uses - row.redemption_count);
  return `${remaining}/${row.max_uses}`;
}
